import { Nullable } from 'utils/types';

export enum FIELD {
  USERNAME = 'username',
  PASSWORD = 'password',
}

export enum FIELD_LABEL {
  USERNAME = 'Email address',
  PASSWORD = 'Password',
}

export type Form = {
  [FIELD.USERNAME]: Nullable<string>;
  [FIELD.PASSWORD]: Nullable<string>;
};
